import { findAllUsers } from '@src/main/modules/user/application/find-all-users.usecase';
import { UserRepository } from '@src/main/modules/user/domain/user.repository';
import { createUserHttpRepository } from '@src/main/modules/user/infrastructure/UserHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useUsers = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<UserRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createUserHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllUsers(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
